import { render, staticRenderFns } from "./LegoBtn.vue?vue&type=template&id=3ee0a96c&scoped=true"
var script = {}
import style0 from "./LegoBtn.vue?vue&type=style&index=0&id=3ee0a96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee0a96c",
  null
  
)

export default component.exports